export default __webpack_public_path__ + "static/media/icon-automated-reminders.dda1d4e6.svg";